import { backButton } from "@tma.js/sdk-react"
import { useEffect } from "react"
import { useLocation, useNavigate } from "react-router-dom"

export const useBackButton = () => {
	const navigate = useNavigate()
	const location = useLocation()
	const isRootTab =
		location.pathname === "/" || location.pathname === "/search" || location.pathname === "/library"

	useEffect(() => {
		if (!backButton.mount.isAvailable()) {
			return
		}

		const isTourOpen = () => document.body.hasAttribute("data-tour-open")

		const updateVisibility = () => {
			if (isRootTab && !isTourOpen()) backButton.hide()
			else backButton.show()
		}

		const handleBack = () => {
			if (isTourOpen()) {
				window.dispatchEvent(new Event("kmk:tour-back"))
				return
			}

			const dialog = document.querySelector<HTMLElement>('[role="dialog"][data-state="open"]')
			if (dialog) {
				dialog.dispatchEvent(new KeyboardEvent("keydown", { key: "Escape", bubbles: true }))
				return
			}

			if (isRootTab) return

			const path = location.pathname
			const parent = path === "/referral" ? "/about" : "/"
			if (window.history.state?.idx > 0) navigate(-1)
			else navigate(parent || "/", { replace: true })
		}

		updateVisibility()
		backButton.onClick(handleBack)
		window.addEventListener("kmk:tour-open", updateVisibility)
		window.addEventListener("kmk:tour-closed", updateVisibility)

		return () => {
			backButton.offClick(handleBack)
			window.removeEventListener("kmk:tour-open", updateVisibility)
			window.removeEventListener("kmk:tour-closed", updateVisibility)
		}
	}, [isRootTab, navigate, location.pathname])
}
